import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "fw-bold mb-3" };
const _hoisted_2 = { class: "rounded bg-white p-3" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-lg-6 col-12" };
const _hoisted_5 = { class: "fs-5 text-secondary" };
const _hoisted_6 = { class: "form-floating mb-3" };
const _hoisted_7 = { class: "form-check mb-3" };
const _hoisted_8 = { class: "form-check mb-3" };
const _hoisted_9 = { class: "form-floating mb-3" };
const _hoisted_10 = { class: "form-floating" };
const _hoisted_11 = { class: "form-floating mb-3" };
const _hoisted_12 = ["value"];
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        defaultPriceBundle: {
            type: Object,
            required: true
        },
        priceBundles: Object,
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        const props = __props;
        const confirm = useConfirm();
        const editDefaultPriceBundle = useForm({
            name: props.defaultPriceBundle.name,
            isApi: props.defaultPriceBundle.isApi,
            isColoring: props.defaultPriceBundle.isColoring,
            colors: props.defaultPriceBundle.colors,
            volume: props.defaultPriceBundle.rules ? props.defaultPriceBundle.rules.volume : null,
            priceBundleUuid: props.defaultPriceBundle.priceBundle.uuid
        });
        function update() {
            editDefaultPriceBundle.transform((data) => ({
                name: data.name,
                isApi: data.isApi,
                isColoring: data.isColoring,
                colors: data.colors,
                volume: data.volume,
                priceBundleUuid: data.priceBundleUuid,
            }))
                .submit('put', route('admin.priceBundles.defaults.update', props.defaultPriceBundle.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function remove() {
            confirm.require({
                message: 'Soll der Default-Preisbundle wirklich gelöscht werden?',
                header: 'Default-Preisbundle löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.priceBundles.defaults.destroy', props.defaultPriceBundle.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Lieferant-Details" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Default-Preis-Bundle: " + _toDisplayString(props.defaultPriceBundle.name), 1),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("form", {
                                        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event) => (update()), ["prevent"]))
                                    }, [
                                        _createElementVNode("p", _hoisted_5, [
                                            _cache[8] || (_cache[8] = _createTextVNode("Typ: ", -1)),
                                            _createElementVNode("strong", null, _toDisplayString(props.defaultPriceBundle.modelType), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editDefaultPriceBundle).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editDefaultPriceBundle).name]
                                            ]),
                                            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "isApi",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editDefaultPriceBundle).isApi) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(editDefaultPriceBundle).isApi]
                                            ]),
                                            _cache[10] || (_cache[10] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "isApi"
                                            }, "API-Default", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "isColoring",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editDefaultPriceBundle).isColoring) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(editDefaultPriceBundle).isColoring]
                                            ]),
                                            _cache[11] || (_cache[11] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "isColoring"
                                            }, "Druck-Default", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "colors",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editDefaultPriceBundle).colors) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editDefaultPriceBundle).colors]
                                            ]),
                                            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "colors" }, "Farb-Anzahl (0=Digitaldruck)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "volumeRule",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editDefaultPriceBundle).volume) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editDefaultPriceBundle).volume]
                                            ]),
                                            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "volumeRule" }, "Volumen in ml (optionale Regel)", -1))
                                        ]),
                                        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "form-text mb-3" }, "Optionale Regel für Flaschen", -1)),
                                        _createElementVNode("div", _hoisted_11, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "priceBundle",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editDefaultPriceBundle).priceBundleUuid) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.priceBundles, (bundle) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: bundle.uuid
                                                    }, _toDisplayString(bundle.name), 9, _hoisted_12));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(editDefaultPriceBundle).priceBundleUuid]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "priceBundle" }, "Preis-Bundle", -1))
                                        ]),
                                        _cache[16] || (_cache[16] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32),
                                    _createElementVNode("button", {
                                        class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                        onClick: _cache[7] || (_cache[7] = ($event) => (remove()))
                                    }, [...(_cache[17] || (_cache[17] = [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-x-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                            ], -1),
                                            _createElementVNode("span", { class: "ms-2" }, "Default löschen", -1)
                                        ]))])
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
